import React from 'react';
import {
	ResponsiveContainer, Tooltip, CartesianGrid, XAxis, YAxis,
	BarChart, Bar
} from 'recharts';
import BlockUi from 'react-block-ui';
import { COLORS } from '../utils';
import { RotatedAxisTick } from '../../../common/components/charts';
import { withTranslation } from 'react-i18next';

const LessonsByGrade = ({ loading, data, height = 300, t }) => {
	return <BlockUi blocking={loading}>
		<ResponsiveContainer height={height}>
			<BarChart data={data}>
				<XAxis tick={<RotatedAxisTick formatter={index => { const item = data[index]; return item && item.shortName; }} />} height={60} />	{/* use the index of the item as dataKey but replace with Grade.ShortName when displaying as tick on X axis */}
				<YAxis orientation='left' stroke={COLORS[0]} axisLine={false} tickLine={false}/>
				<CartesianGrid vertical={false} />
				<Tooltip labelFormatter={index => { const item = data[index]; return item && item.name; }} />		{/* use the index of the item as dataKey but replace with Grade.Name when displaying as label in the Tooltip */}
				<Bar stackId='grade' name={t('OperationsDashboard_Missed')} dataKey='missedLessons' fill={COLORS[3]} key={3} />
				<Bar stackId='grade' name={t('OperationsDashboard_Attended')} dataKey='attendedLessons' fill={COLORS[1]} key={2} />
				<Bar stackId='grade' name={t('OperationsDashboard_FutureClasses')} dataKey='futureLessons' fill={COLORS[0]} key={1}/>
			</BarChart>
		</ResponsiveContainer>
	</BlockUi>;
};

export default withTranslation()(LessonsByGrade);